export type ThemeMode = 'light' | 'dark' | 'auto';
export type ResolvedTheme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'cd-theme-mode';
const DAY_START_HOUR = 7;
const NIGHT_START_HOUR = 19;

/** Auto follows the device clock like the prototype: light 07:00–19:00, dark otherwise.
 *  (Keep in sync with the pre-paint script in index.html.) */
export function resolveTheme(mode: ThemeMode, now: Date = new Date()): ResolvedTheme {
  if (mode !== 'auto') return mode;
  const h = now.getHours();
  return h >= DAY_START_HOUR && h < NIGHT_START_HOUR ? 'light' : 'dark';
}

export function isThemeMode(value: unknown): value is ThemeMode {
  return value === 'light' || value === 'dark' || value === 'auto';
}
